<script>
import { defineComponent, h } from 'vue';
import { mapGetters } from 'vuex';
import { isChannelAllowed } from 'dashboard/constants/accessControl';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import Infobip from './channels/Infobip.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Instagram from './channels/Instagram.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';
import MazamWeb from './channels/MazamWeb.vue';

const channelViewList = {
  mazamweb: MazamWeb,
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  infobip: Infobip,
  line: Line,
  telegram: Telegram,
  instagram: Instagram,
  tiktok: Tiktok,
  voice: Voice,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Esconder o card não basta: o canal vem como parâmetro da URL
    // (/settings/inboxes/new/whatsapp), então quem souber o endereço entraria
    // direto. Aqui a permissão é conferida de novo antes de montar a tela.
    ...mapGetters({ currentUser: 'getCurrentUser' }),
    allowed() {
      return isChannelAllowed(this.currentUser, this.channelName);
    },
  },
  render() {
    const ChannelComponent = channelViewList[this.channelName];
    if (!ChannelComponent || !this.allowed) return null;
    return h(ChannelComponent);
  },
});
</script>
